import React, { useState } from "react";
import classes from "./ForgotPassword.module.css";
import bigcirlce from "../../Assets/bigcircle.svg";
import smallcirlce from "../../Assets/smallcircle.svg";
import promix from "../../Assets/Promix.svg";
import cal from "../../Assets/calculate.svg";
import accend from "../../Assets/accend.svg";
import corporate from "../../Assets/corporate.svg";
import smallsquare from "../../Assets/smallsquare.svg";
import bigsquare from "../../Assets/bigsquare.svg";
import eye from "../../Assets/eye.svg";
import eyesoff from "../../Assets/eyesoff.svg"
import { Link } from "react-router";
import axios from 'axios';
import { BASE_URL } from '../../Components/API/Api';
import Swal from "sweetalert2";
import { useUser } from '../../UserContext';
import { useNavigate } from "react-router-dom";


const ForgotPassword = () => {
    const { login } = useUser();
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();



    const handleLogin = async () => {
        if (!email) {
            Swal.fire('Error', 'Email is required', 'error');
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${BASE_URL}/v1/login`, {
                email,
            });

            const token = response.data?.data?.token;

            // Debug: Log the API response to see the structure
            console.log('API Response:', response.data);

            // Extract user data - prioritize the direct name field
            const userData = {
                name: response.data?.data?.name || 'User',
                email: email
            };

            // If there's a nested user object, merge it
            if (response.data?.data?.user) {
                Object.assign(userData, response.data.data.user);
            }

            console.log('Extracted user data:', userData);

            if (!token) {
                throw new Error("Token not returned from server.");
            }

            // Store user data in context and localStorage
            login(userData, token);

            // Swal.fire('Success', 'Login successful', 'success');

            // Give the UserContext time to update before redirecting
            setTimeout(() => {
                window.location.href = "/dashboard";
            }, 2000);
        } catch (error) {
            console.error('Login error:', error);
            console.error('Error response:', error.response?.data);
            // Swal.fire('Login Failed', error.response?.data?.message || error.message, 'error');
        } finally {
            setLoading(false);
        }
        navigate("/otpverification");

    };


    const handleSendOtp = async () => {
        if (!email) {
            Swal.fire("Error", "Email is required", "error");
            return;
        }

        setLoading(true);

        try {
            const response = await axios.post(`${BASE_URL}/v1/send_otp`, {
                email,
            });

            console.log("API Response:", response.data);

            Swal.fire(
                "Success",
                response.data?.message || "OTP sent successfully!",
                "success"
            );

            // Store email in localStorage for OTP verification
            localStorage.setItem("email", email);

            // Redirect to OTP verification page
            navigate("/otpverification");
        } catch (error) {
            console.error("OTP error:", error);
            Swal.fire(
                "There is no account linked to the provided email",
                error.response?.data?.message || error.message,
                "error"
            );
        } finally {
            setLoading(false);
        }
    };




    return (
        <div>
            <div className={classes.main}>
                <div className={classes.leftside}>
                    <img src={bigcirlce} className={classes.paint} />
                    <img src={smallcirlce} className={classes.point} />

                    <div className={classes.grit}>
                        <img src={promix} className={classes.pro} />
                        <p className={classes.fir_txt}>
                            Smart Accounting for Nigerian Businesses
                        </p>
                        <p className={classes.sec_txt}>
                            Streamline your finances with AI-powered tools designed
                            specifically for SMEs in Nigeria
                        </p>

                        <div className={classes.joptd}>
                            <div>
                                <img src={cal} />
                            </div>
                            <div>
                                <p className={classes.cro_pt}>Complete Accounting Suite</p>
                                <p className={classes.mind}>
                                    Everything you need to manage your finances
                                </p>
                            </div>
                        </div>
                        <div className={classes.joptd}>
                            <div>
                                <img src={accend} />
                            </div>
                            <div>
                                <p className={classes.cro_pt}>Growth Analytics</p>
                                <p className={classes.mind}>
                                    Track your business growth with detailed reports
                                </p>
                            </div>
                        </div>
                        <div className={classes.joptd}>
                            <div>
                                <img src={corporate} />
                            </div>
                            <div>
                                <p className={classes.cro_pt}>Team Collaboration</p>
                                <p className={classes.mind}>
                                    Work together with your team seamlessly
                                </p>
                            </div>
                        </div>

                        <div className={classes.mvt}>
                            <button className={classes.pthd}>View Features</button>
                            <button className={classes.simp}>Contact Sales</button>
                        </div>
                        <img src={smallsquare} className={classes.bi_squ} />
                        <img src={bigsquare} className={classes.sm_squ} />
                    </div>
                </div>

                <div className={classes.right}>
                    <div className={classes.protw}>
                        <p className={classes.cre_top}>Forgot Password</p>
                    </div>

                    <div className={classes.portned} onKeyDown={(e) => e.key === "Enter" && handleSendOtp()}>
                        <div className={classes.coprte}>
                            <label>Email Address</label>
                            <input
                                type="text"
                                placeholder="Enter your email"
                                className={classes.print}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </div>

                    </div>



                    <button
                        className={classes.sign}
                        onClick={handleSendOtp}
                        disabled={loading}
                    >
                        {loading ? <span className={classes.spinner}></span> : "Submit"}
                    </button>



                </div>
            </div>
        </div>
    );
};

export default ForgotPassword;
